import React from 'react';
import VersionStatsTable from './VersionStatsTable';
import TableSkeleton from './skeletons/TableSkeleton';
import { MetricLineChartCard } from './charts/MetricLineChartCard';
import { DashboardViewModel } from './hooks/useDashboardViewModel';
import type { DashboardChartVisibility } from './hooks/useDashboardChartVisibility';

interface DashboardChatAdsGridProps {
  loading: boolean;
  versionStatsLoading: boolean;
  overviewMetricsEmpty: boolean;
  vm: DashboardViewModel;
  visibility: DashboardChartVisibility;
}

export const DashboardChatAdsGrid: React.FC<DashboardChatAdsGridProps> = ({
  loading,
  versionStatsLoading,
  overviewMetricsEmpty,
  vm,
  visibility,
}) => {
  const {
    hiddenChatVersions,
    setHiddenChatVersions,
    hiddenAdvertisementVersions,
    setHiddenAdvertisementVersions,
    hiddenAllVersionsLine,
    setHiddenAllVersionsLine,
  } = visibility;

  if (loading && overviewMetricsEmpty) {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <TableSkeleton title="Açılan Chat Sayısı" rows={5} columns={5} />
        <TableSkeleton title="Reklamlar" rows={5} columns={5} />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="space-y-6">
        <VersionStatsTable
          title="Açılan Chat Sayısı"
          stats={vm.chatSessionVersionStats}
          totalsFromStats={vm.allChatSessionVersionStats}
          loading={versionStatsLoading}
          detailLink="/opened-chats"
        />
        <MetricLineChartCard
          title="Açılan Chat Sayısı"
          data={vm.filteredChatSessionChartData}
          versionStatsTop={vm.chatSessionVersionStats}
          allVersionsTotalCount={vm.allChatSessionVersionStats.length}
          hiddenVersions={hiddenChatVersions}
          setHiddenVersions={setHiddenChatVersions}
          allVersionsLineKey="chat_session"
          hiddenAllVersionsLine={hiddenAllVersionsLine}
          setHiddenAllVersionsLine={setHiddenAllVersionsLine}
        />
      </div>

      <div className="space-y-6">
        <VersionStatsTable
          title="Reklamlar"
          stats={vm.advertisementVersionStatsTop}
          totalsFromStats={vm.advertisementVersionStats}
          loading={versionStatsLoading}
          detailLink="#"
        />
        {vm.filteredAdvertisementChartData.length > 0 && (
          <MetricLineChartCard
            title="Reklamlar"
            data={vm.filteredAdvertisementChartData}
            versionStatsTop={vm.advertisementVersionStatsTop}
            allVersionsTotalCount={vm.advertisementVersionStats.length}
            hiddenVersions={hiddenAdvertisementVersions}
            setHiddenVersions={setHiddenAdvertisementVersions}
            allVersionsLineKey="advertisements"
            hiddenAllVersionsLine={hiddenAllVersionsLine}
            setHiddenAllVersionsLine={setHiddenAllVersionsLine}
          />
        )}
      </div>
    </div>
  );
};
